module.exports = __webpack_public_path__ + "src/assets/img/potok.0fd38336.jpg";